export enum OrderType {
  FTL = 'FTL',
  LTL = 'LTL',
}
